import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./styles/App.css";
import routes from "./routes";
import Settings from "./pages/Settings";
import Header from "./components/layout/Header";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className={`app-container ${isDarkMode ? "dark-mode" : ""}`}>
      <Header isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <div className="main-content">
        <Routes>
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                route.path === "/settings" ? (
                  <Settings
                    isDarkMode={isDarkMode}
                    toggleDarkMode={toggleDarkMode}
                  />
                ) : (
                  route.element
                )
              }
            />
          ))}
        </Routes>
      </div>
    </div>
  );
}

export default App;
